import { render, staticRenderFns } from "./our-brand.en.vue?vue&type=template&id=cbc20992&"
import script from "./our-brand.en.vue?vue&type=script&lang=js&"
export * from "./our-brand.en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports